import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="December 2025">
      <section data-testid="privacy-content">
        <div>
          <h2>Overview</h2>
          <p>
            JLY Services ("we", "us", "our") respects your privacy. This policy
            explains what information we collect, how we use it, and your rights.
            By using our website and services, you agree to the practices described
            here.
          </p>
        </div>
        <div>
          <h2>Information we collect</h2>
          <p>
            We collect information you provide directly, such as your name, email
            address, selected service and any message you send via our contact form.
            We may also collect basic technical data (such as browser type) to help
            us operate and improve the site.
          </p>
        </div>
        <div>
          <h2>How we use your information</h2>
          <p>
            We use your information to respond to enquiries, provide quotes and
            services, and communicate with you about your request. We do not sell
            your personal information to third parties.
          </p>
        </div>
        <div>
          <h2>Data sharing</h2>
          <p>
            Where relevant to fulfilling your request (for example, obtaining a solar
            quote), we may share necessary details with vetted providers on your
            behalf. We share only what is required and expect partners to handle your
            data responsibly.
          </p>
        </div>
        <div>
          <h2>Data retention &amp; security</h2>
          <p>
            We retain enquiry information only as long as needed to serve you and meet
            legal obligations, and we apply reasonable measures to protect it against
            unauthorised access.
          </p>
        </div>
        <div>
          <h2>Your rights</h2>
          <p>
            You may request access to, correction of, or deletion of your personal
            information at any time via our <a href="/#contact" className="text-primary underline underline-offset-2">contact form</a>.
          </p>
        </div>
        <div>
          <h2>Contact</h2>
          <p>
            For any privacy questions, please reach us through the <a href="/#contact" className="text-primary underline underline-offset-2">contact form</a> on our website.
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
